// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__34QTf","radioRow":"SimpleQuestionBuilderModal_radioRow__3CQvq"};